class SnowplowEvent {
  constructor(schema, actionMap) {
    this.schema = schema
    this.actionMap = actionMap
  }

  getSchema() {
    return this.schema
  }

  analytics(data, contexts) {
    return {
      event: {
        schema: this.schema,
        data
      },
      contexts
    }
  }

  build(event, action) {
    let builtEvent = Object.assign({}, event)

    /*
      The actionMap property is getting pulled in from the base event
      initialization (see events/index.js... second argument) which could
      be included in the payload if not removed here.

      It's uncertain regarding all times this function gets called, but in the case
      of the ticket referenced below, we have an instance of SnowplowEvent
      passing another instance of a SnowplowEvent as an argument to its build
      method.

      See https://credible.atlassian.net/browse/PLIS-1410.
    */
    delete builtEvent.actionMap

    if (action && this.actionMap) {
      const data = {}

      Object.keys(this.actionMap).forEach(key => {
        const dataKey = typeof this.actionMap[key] === 'function' ? this.actionMap[key](action) : this.actionMap[key]

        data[key] = action[dataKey]
      })

      builtEvent.data = Object.assign(data, event.data)
    }

    return builtEvent
  }
}

export {SnowplowEvent}

export default SnowplowEvent
